export const globalMixin = {
    data() {
        return {

        }
    },
    methods: {
        erroFormatar(e) {
            return e.response.data.erro.split(';').join("<br />")
        },
        permissao(perm) {
            let usuarioSessao = JSON.parse(localStorage.getItem('comercialivaipora_gestor'))
            return usuarioSessao.permissao.filter((p) => {
                return p.idpermissao == perm
            }).length > 0
        },
        downloadBase64(res){
            const url = window.URL.createObjectURL(this.base64ToBlob(res.arquivo, res.type))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', res.arquivoname)
            document.body.appendChild(link)
            return link.click()
        },
        base64ToBlob(b64Data, contentType='', sliceSize= 512) {
            const byteCharacters = atob(b64Data)
            const byteArrays = []
            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize)
                const byteNumbers = new Array(slice.length)
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i)
                }
                const byteArray = new Uint8Array(byteNumbers)
                byteArrays.push(byteArray)
            }
            const blob = new Blob(byteArrays, {type: contentType})
            return blob
        },
        formataDinheiro(v) {
            if (v == "" || v == null) {
                v = 0
            }
            return parseFloat(v).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
        },
        formataNumero(v) {
            if (v === "" || v == null || v === 0) {
                return '-';
            }
            return parseFloat(v).toLocaleString('pt-BR');
        },
        formataPercentual(v, zero) {
            if (v === "" || v == null || v === 0) {
                if (zero) {
                    return (0).toFixed(2);
                } else {
                    return '-';
                }

            }
            return parseFloat(v).toFixed(2);
        },
        formataData(v) {
            return v.split('T')[0].split('-').reverse().join('/')
        },

        // novas funçoes
        formatarNumero(valor, decimais = 3,  separador = ',', valor_default= '-') {
            if (valor === null || valor === undefined || valor === '') {
                return valor_default;
            }

            const numero = Number(valor);

            if (isNaN(numero)) {
                return valor_default;
            }

            try {
                const locale = separador === ',' ? 'pt-BR' : 'en-US';
                return numero.toLocaleString(locale, {
                    minimumFractionDigits: decimais,
                    maximumFractionDigits: decimais
                });
            } catch (error) {
                return String(valor);
            }
        },

        formatarDataArquivo() {
            const agora = new Date()
            const ano = agora.getFullYear()
            const mes = String(agora.getMonth() + 1).padStart(2, '0')
            const dia = String(agora.getDate()).padStart(2, '0')
            const hora = String(agora.getHours()).padStart(2, '0')
            const minuto = String(agora.getMinutes()).padStart(2, '0')

            return `${ano}${mes}${dia}_${hora}${minuto}`
        },

        formatarData(data) {
            if (!data) return '';
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        },

        formatarMoeda(valor) {
            if (!valor && valor !== 0) return ''

            try {
                return Number(valor).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                })
            } catch (error) {
                return String(valor)
            }
        },

        formatarPercentual(valor) {
            return typeof valor === 'number' ? valor.toFixed(2) + '%' : '-';
        },

        // cor por classificação (OURO/PRATA/BRONZE/NÃO ATINGIU) da Campanha de Vendas — usada tanto na
        // visão de diretoria (CampanhaVendaMargem.vue) quanto na visão do vendedor (DashboardVendas.vue)
        classificacaoCor(classificacao) {
            if (classificacao === 'OURO') return 'amber darken-2';
            if (classificacao === 'PRATA') return 'grey darken-1';
            if (classificacao === 'BRONZE') return 'brown darken-1';
            return 'red darken-2';
        },

        // mesmas cores de classificacaoCor(), em RGB — usado no desenho vetorial do PDF de cupons (jsPDF não
        // entende classe do Vuetify, só setFillColor(r,g,b))
        classificacaoCorRGB(classificacao) {
            if (classificacao === 'OURO') return [255, 143, 0]; // amber darken-2
            if (classificacao === 'PRATA') return [117, 117, 117]; // grey darken-1
            if (classificacao === 'BRONZE') return [93, 64, 55]; // brown darken-1
            return [198, 40, 40]; // red darken-2
        },
    }
};